import { render } from "./fetchData.vue?vue&type=template&id=59d3b842"
import script from "./fetchData.vue?vue&type=script&lang=js"
export * from "./fetchData.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/vue/mainComp/fetchData.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "59d3b842"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('59d3b842', __exports__)) {
    api.reload('59d3b842', __exports__)
  }
  
  module.hot.accept("./fetchData.vue?vue&type=template&id=59d3b842", () => {
    api.rerender('59d3b842', render)
  })

}


export default __exports__